import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useQuery } from 'react-query';



import { appConfig } from '../../../../config/app';
import { CustomEvents } from '../../../../constants/analytics.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import {
  POLICIES_QUERY,
  POLICIES_QUERY_CONFIG,
  policiesQuery,
} from '../../../../query/policies/policies';
import {
  PRODUCTS_QUERY,
  PRODUCTS_QUERY_CONFIG,
  productsQuery,
} from '../../../../query/products/products';
import { useStyle } from './styles';
import useLogEventInAnalytics from '../../../../hooks/useLogAnalyticsEvent';

const usePayments = () => {
  const [open, setOpen] = useState(false);
  const [listProducts, setListProducts] = useState(false);
  const [productsF, setProductsF] = useState<any[]>([]);
  const classes = useStyle();
  const { user } = useAuthDataContext();
  const { logEvent } = useLogEventInAnalytics();

  const logAnalytics = async () => {
    await logEvent(CustomEvents.OPEN_WHATSAPP, {
      app: appConfig?.NAME,
    });
  };

  const { data: policies, isLoading: loading } = useQuery(
    [POLICIES_QUERY, { name: 'product_codes', value: productsF.join(',') }],
    policiesQuery,
    POLICIES_QUERY_CONFIG
  );

  const { data: products, isLoading: loadingP } = useQuery(
    PRODUCTS_QUERY,
    productsQuery,
    PRODUCTS_QUERY_CONFIG
  );

  useEffect(() => {
    if (products && products.length > 1) {
      setListProducts(true);
    }
  }, [products]);

  const filterProduct = useCallback((productsFilter) => {
    setProductsF(productsFilter);
  }, []);

  const finishSelection = useCallback(
    (selectedProducts) => {
      dataLayerPush('mis_pagos_productos', user?.id, {
        fieldName: 'params',
        fieldValue: selectedProducts,
      });
      dataLayerPush('mis_pagos_poliza_consulta', user?.id);
      if (productsF.length >= 1) {
        if (productsF.includes(4)) {
          logEvent(CustomEvents.PAYMENTS_VIEW_VEHICLE_ONLY, {
            app: appConfig?.NAME,
          });
        } else {
          logEvent(CustomEvents.PAYMENTS_VIEW_OTHER_PRODUCTS, {
            app: appConfig?.NAME,
          });
        }

        if (productsF.length >= 2) {
          logEvent(CustomEvents.PAYMENTS_VIEW_OTHER_PRODUCTS, {
            app: appConfig?.NAME,
          });
        }
      }
      setListProducts(false);
    },
    [productsF, user]
  );

  return {
    loading,
    loadingP,
    open,
    logAnalytics,
    setOpen,
    listProducts,
    filterProduct,
    finishSelection,
    setListProducts,
    policies,
    classes,
  };
};

export default usePayments;
